import ImageClass, { asImages } from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { chris } from "../characters/Chris";
import { mc } from "../characters/MC";
import { v1AfterDates } from "./V1";

const images = asImages({
    BarAnnHello: { url: require("@lss/common/game/assets/images/V1/BarAnnHello.webp") },
    BarAnnSmile: { url: require("@lss/common/game/assets/images/V1/BarAnnSmile.webp") },
    BarAnnTalk1HandBehind: { url: require("@lss/common/game/assets/images/V1/BarAnnTalk1HandBehind.webp") },
    BarAnnNaturalHandBehind: { url: require("@lss/common/game/assets/images/V1/BarAnnNaturalHandBehind.webp") },
    BarAnnTalk2HandBehind: { url: require("@lss/common/game/assets/images/V1/BarAnnTalk2HandBehind.webp") },
    BarAnnBartender1_1: { url: require("@lss/common/game/assets/images/V1/BarAnnBartender1_1.webp") },
    BarAnnBartender1: { url: require("@lss/common/game/assets/images/V1/BarAnnBartender1.webp") },
    BarAnnBartender2: { url: require("@lss/common/game/assets/images/V1/BarAnnBartender2.webp") },
    BarAnnBartender3: { url: require("@lss/common/game/assets/images/V1/BarAnnBartender3.webp") },
    BarAnnBartender5: { url: require("@lss/common/game/assets/images/V1/BarAnnBartender5.webp") },
    BarAnnAlone: { url: require("@lss/common/game/assets/images/V1/BarAnnAlone.webp") },
    BarAnnBartender4: { url: require("@lss/common/game/assets/images/V1/BarAnnBartender4.webp") },
    BarAnnSmileDrink: { url: require("@lss/common/game/assets/images/V1/BarAnnSmileDrink.webp") },
    BarAnn1: { url: require("@lss/common/game/assets/images/V1/BarAnn1.webp") },
    BarAnnSurpriseDrink: { url: require("@lss/common/game/assets/images/V1/BarAnnSurpriseDrink.webp") },
    BarAnnSmileHandBehind: {
        url: require("@lss/common/game/assets/images/V1/BarAnnSmileHandBehind.webp"),
        partials: {
            BarAnnTalk1_PAR: { url: require("@lss/common/game/assets/images/V1/BarAnnTalk1_PAR.webp") },
            BarAnnTalk2_PAR: { url: require("@lss/common/game/assets/images/V1/BarAnnTalk2_PAR.webp") },
        }
    },
    BarAnnBartender7: { url: require("@lss/common/game/assets/images/V1/BarAnnBartender7.webp") },
});



export const v1AnnBarMeeting = async () => {
    ImageClass.setImage(images.BarAnn1, { transition: true, duration: 0.6 });
    if (mc.properties.metAnn) {
        mc.think(`There's Ann, she got here quick!`);
    } else {
        mc.think(`Joey wasn't kidding, the bar is really empty.`);
        mc.think(`There is just this girl sitting alone, that must be Ann.`);

        ImageClass.setImage(images.BarAnnHello);
        mc.talk(`Hey, Ann?`);
        ann.talk(`Yes, that's me. You must be ${mc.name}.`);
        mc.talk(`Yes.`);
    }


    ImageClass.setImage(images.BarAnnSmileHandBehind);
    ann.talk(`It's so weird for me being here, I never go out to places like this.`);
    if (Question.globalAnswers.v1AnnAskFreeTime === "playGames") {

        mc.talk(`To be honest, me neither.`);
    }
    if (!mc.properties.metAnn) {
        ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
        ann.talk(`Let alone with guy I've never met before.`);

        ImageClass.setImage(images.BarAnnSmile);
        mc.talk(`Likewise, but with a girl not with a man.`);
        ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
        ann.talk(`Yes I got it hehe.`);
    } else {

        ann.talk(`But I'm sure you won't kidnap me! You could have done it at the library already so I feel safe hehe.`);
    }

    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);

    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk2_PAR);
    ann.talk(`So what do you do in a place like this when you don't drink?`);

    return jump(v1AnnBarMeeting2, "v1AnnBarMeeting2");
};

export const v1AnnBarMeeting2 = async () => {

    ImageClass.setImage(images.BarAnnSmile);
    mc.talk(`Mmm... Just pass the time by talking...`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`Great! I'm good at talking.`);
    ImageClass.setImage(images.BarAnnSmile);
    mc.talk(`Have you never tried drinking?`);
    ImageClass.setImage(images.BarAnnTalk1HandBehind);
    ann.talk(`Nope... I mean, I tried it once because Vanessa made me, but it was just a taste. I didn't like it.`);
    ImageClass.setImage(images.BarAnnNaturalHandBehind);
    mc.talk(`You get used to it.`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`Yeah, maybe in the future, now I'm good with just water. Hehe.`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk2_PAR);
    ann.talk(`It's good that this place is empty, I don't like crowds. I mean I'm not a loner or anything. I am fine with a couple of people, but I don't like to be in crowded places.`);

    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`Too much noise and too many eyes.`);
    ImageClass.setImage(images.BarAnnSmile);
    mc.talk(`I can relate, that's why I spent most of my time in front of the computer.`);
    if (Question.globalAnswers.v1AnnAskFreeTime === "goingOut") {
        ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
        ann.talk(`But you said you spend most of your time going out.`);
        ImageClass.setImage(images.BarAnnSmile);
        mc.talk(`I have plenty of free time, enough to do both.`);
        ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
        ann.talk(`Oh ok.`);
    }
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk2_PAR);
    ann.talk(`I never understood computers, but many people don't understand why I have so much fun reading books so I guess it's the same.`);
    if (mc.properties.metVanessa) {
        ImageClass.setImage(images.BarAnnSmile);
        mc.talk(`Vanessa said that we have a lot in common, I guess computers is not one of them.`);

        ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
        ann.talk(`Yeah... But I'm sure we will find something else we have in common.`);
    }

    return jump(v1AnnBarMeeting3, "v1AnnBarMeeting3");

};

export const v1AnnBarMeeting3 = async () => {

    ImageClass.setImage(images.BarAnnSmile);
    mc.talk(`So, how did you and Vanessa meet?`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`Our parents are good friends and they used to bring her over when they met so we became friends.`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk2_PAR);
    ann.talk(`She is so different from me as you can probably tell by now.\nI still consider her a good friend of mine.`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`Even though I keep refusing her suggestions to go out, she still keeps inviting me.`);

    ImageClass.setImage(images.BarAnnSmile);
    mc.talk(`You don't need to like the same stuff to get along.`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`Yeah, like you and Joe right?`);
    ImageClass.setImage(images.BarAnnSmile);
    mc.talk(`That's different. Joey and I used to do everything together until he became Joe. Now he is more like Vanessa.`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`Oh wow, I never met him, I just heard of him.`);
    //   bartender arrived
    ImageClass.setImage(images.BarAnnBartender1_1);
    chris.talk(`Hi I am Chris, your bartender, how can I serve you?`);
    mc.talk(`Hi Chris. Beer for me, thanks.`);
    ImageClass.setImage(images.BarAnnBartender1);
    ann.talk(`I would like to have a glass of water please.`);
    ImageClass.setImage(images.BarAnnBartender2);
    chris.talk(`Water? Really?`);
    ann.talk(`Yes yes I know...`);
    ImageClass.setImage(images.BarAnnBartender1);
    chris.talk(`Ok your choice, beer and water coming right up.`);
    //   bartender left
    ImageClass.setImage(images.BarAnnTalk1HandBehind);
    ann.talk(`You see, even the bartender almost laughed at me for ordering water in a bar.`);
    ImageClass.setImage(images.BarAnnSmile);
    mc.talk(`Well, his job is to get people drunk and you can't do that with water.`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`Why would he want to get people drunk?`);
    ImageClass.setImage(images.BarAnnSmile);
    mc.talk(`So they'll give bigger tips; if people are drunk that means they are having fun.`);

    ImageClass.setImage(images.BarAnnTalk2HandBehind);
    ann.talk(`I never thought about it like that, hehe I guess you are right.`);
    //   bartender came with drinks
    ImageClass.setImage(images.BarAnnBartender3);



    chris.talk(`There you go.`);
    chris.talk(`Beer for the gentleman and a glass of water for the lovely lady, enjoy the rest of your evening.`);
    ann.talk(`Thank you hehe.`);
    //   LEFT
    ImageClass.setImage(images.BarAnnSmileDrink);
    ann.talk(`So ${mc.name} you never told me your plans for the future.`);

    mc.talk(`I don't have something special in mind.`);
    mc.talk(`My parents are always away so I have the house all to myself so you can say that I feel like an adult already.`);

    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`Oh... It must be really lonely.`);
    ImageClass.setImage(images.BarAnnSmileDrink);
    mc.talk(`I have my online friends so I never feel alone.`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`Are you popular online?`);
    ImageClass.setImage(images.BarAnnSmileDrink);
    mc.talk(`I'm doing alright.`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`Oh hehe. Ok.`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`I am going to the restroom, be right back!`);
    ImageClass.setImage(images.BarAnnSmileDrink);
    mc.talk(`I'll be here.`);
    //   Mc left alone
    ImageClass.setImage(images.BarAnnAlone, { duration: 0.6, transition: true });
    mc.think(`She is kinda cute.`);
    if (mc.properties.metVanessa) {

        mc.think(`So different from Vanessa, I can't imagine them being friends were it not for their parents.`);
    }

    //   bartender came
    ImageClass.setImage(images.BarAnnBartender4);
    chris.talk(`Hey man I was waiting for a chance to catch you alone.`);
    mc.talk(`Yes?`);
    ImageClass.setImage(images.BarAnnBartender5);

    chris.talk(`Is this girl your girlfriend?`);
    mc.talk(`No, why?`);
    if (Question.globalAnswers.v1EnableNTR) {
        return jump(v1AnnBarMeeting4, "v1AnnBarMeeting4");
    }

    chris.talk(`I was wondering, would you mind if I ask her for her number.`);
    return jump(v1AnnBarMeeting4_DidntAllowChris, "v1AnnBarMeeting4_DidntAllowChris");

};

export const v1AnnBarMeeting4 = async () => {

    await chris.setQuestion(new Question({ text: 'I was wondering, would you mind if I ask her for her number.', key: `v1AllowChrisGetAnnsNumber` })
        .option({ title: `I would mind`, key: false })
        .option({ title: `I wouldn't mind`, key: true }));

    if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
        return jump(v1AnnBarMeeting4_AllowedChris, "v1AnnBarMeeting4_AllowedChris");
    }

    return jump(v1AnnBarMeeting4_DidntAllowChris, "v1AnnBarMeeting4_DidntAllowChris");
};
export const v1AnnBarMeeting4_AllowedChris = async () => {


    ImageClass.setImage(images.BarAnnBartender4);
    mc.talk(`I wouldn't mind that at all.`);

    chris.talk(`Cool dude! I'll come back once she's back.`);
    return jump(v1AnnBarMeeting5, "v1AnnBarMeeting5");


};
export const v1AnnBarMeeting4_DidntAllowChris = async () => {
    ImageClass.setImage(images.BarAnnBartender4);
    mc.talk(`I would mind.`);
    chris.talk(`Why? If you aren't together, why does it matter?`);
    mc.talk(`We are not together.`);
    chris.talk(`Oh... Fine, I'll leave you to it. Enjoy the rest of your evening.`);
    chris.talk(`I'll be at the bar, raise your hand if you need anything.`);

    return jump(v1AnnBarMeeting5, "v1AnnBarMeeting5");
};

export const v1AnnBarMeeting5 = async () => {

    //   Bartender left
    ImageClass.setImage(images.BarAnnAlone);
    mc.think(`What was that all about?`);
    //   Ann is back
    ImageClass.setImage(images.BarAnnSmileDrink, { duration: 0.4 });
    ann.talk(`BACK!`);

    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`I saw you talking with the bartender, is everything alright? I hope he isn't kicking us out.`);

    ImageClass.setImage(images.BarAnnSmileDrink);
    mc.talk(`Nope, he isn't.`);
    if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
        ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
        ann.talk(`So what did he want?`);
        mc.talk(`You'll see.`);
    } else {
        await ann.setQuestion(new Question({ text: 'So what did he want?', key: `v1WhatChrisWanted` })
            .option({ title: `Tell the truth`, key: 'truth' })
            .option({ title: `Lie`, key: 'lie' }));
        if (Question.globalAnswers.v1WhatChrisWanted === "truth") {
            await mc.set((properties) => {
                properties.liar--;
            });
            mc.talk(`I think he is into you. He asked if we are together to get your number.`);
            ImageClass.setImage(images.BarAnnSurpriseDrink);
            ann.talk(`Really?? Me?`);
            mc.talk(`Yes.`);
            ImageClass.setImage(images.BarAnnSmileDrink);
            ann.talk(`What did you say?`);
            mc.talk(`I said that you are not my girlfriend but he can't have your number.`);
            ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk2_PAR);
            ann.talk(`Oh ok. Good... He is good looking and all but I don't want anything to do with a person like that.`);
        } else {
            await mc.set((properties) => {
                properties.liar++;
            });

            ImageClass.setImage(images.BarAnnSmileDrink);
            mc.talk(`He just asked if we need anything. I said no, so he left.`);
            ann.talk(`Oh, ok great.`);
        }

    }

    ImageClass.setImage(images.BarAnnSmileDrink);


    mc.talk(`So Ann, have you ever had a boyfriend before?`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`Not really... I used to meet guys here and there, but none I'd call my boyfriend...`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk2_PAR);
    ann.talk(`They were all just friends.`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`You see, I spend most of my time at the library so the guys I meet aren't the type of guys who show confidence, most of the time... so we just stay good friends.`);

    ImageClass.setImage(images.BarAnnSmileDrink);
    await ann.setQuestion(new Question({ text: 'What about you?', key: `v1BarQuestion` })
        .option({ title: `Tell the truth`, key: 'truth' })
        .option({ title: `Lie`, key: 'lie' })
        .option({ title: `Flirt`, key: 'flirt' }));
    if (Question.globalAnswers.v1BarQuestion === "truth") {
        await mc.set((properties) => {
            properties.liar--;
        });
        ImageClass.setImage(images.BarAnnSmileDrink);
        mc.talk(`Not really... more or less like you.`);
    } else if (Question.globalAnswers.v1BarQuestion === "lie") {
        await mc.set((properties) => {
            properties.liar++;
        });
        ImageClass.setImage(images.BarAnnSmileDrink);
        mc.talk(`I've had lots of girlfriends, I lost count on how many.`);
        ann.talk(`Oh... ok...`);
    } else {
        ImageClass.setImage(images.BarAnnSmileDrink);
        mc.talk(`I am hoping you will be my next girlfriend.`);
        ImageClass.setImage(images.BarAnnSurpriseDrink);
        ann.talk(`Oh really?`);
        ImageClass.setImage(images.BarAnnSmileDrink);
        ann.talk(`Hehe.`);
    }


    // bartender came back
    ImageClass.setImage(images.BarAnnBartender7);
    chris.talk(`Hey there again. Is everything fine?`);
    ann.talk(`Yes we are doing well, thanks.`);
    if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
        chris.talk(`Great. But there is one thing missing.`);

        ann.talk(`What's that?`);
        chris.talk(`Your number.`);
        ann.talk(`My number?`);
        chris.talk(`Yes.`);
        ann.talk(`Why, do you need my number?`);
        chris.talk(`To talk to you of course.`);
        chris.talk(`Come on say it, I will remember. I have a good memory.`);
        ann.talk(`I guess it couldn't hurt... My number is 91-3267-666.`);
        chris.talk(`Great, expect a call from me.`);
    }
    chris.talk(`That will be all, enjoy the rest of your evening.`);
    if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
        ImageClass.setImage(images.BarAnnSurpriseDrink);
        ann.talk(`So is that what you meant by "you will see".`);
        ImageClass.setImage(images.BarAnnSmileDrink);
        mc.talk(`Yea.`);
        ImageClass.setImage(images.BarAnnSmileDrink);
        ann.talk(`I never thought a guy would ask for a girl's number while she is sitting with someone.`);

        mc.talk(`Yet you gave it to him.`);

        ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
        ann.talk(`He didn't give me much of a choice.`);
        ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk2_PAR);
        ann.talk(`You could have said something... I can hang up on him if he calls.`);
        ImageClass.setImage(images.BarAnnSmileDrink);
        mc.talk(`No, it's fine.`);
    }



    ImageClass.setImage(images.BarAnnSmileDrink);
    mc.talk(`I think we should get going now.`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`Yes, I agree.`);
    ImageClass.setImage(images.BarAnnSmileDrink);
    mc.talk(`I had a really good time.`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`Yes me too.`);
    ImageClass.setImage(images.BarAnnSmileDrink);
    mc.talk(`Good night Ann.`);
    ImageClass.setImage(images.BarAnnSmileHandBehind.partials.BarAnnTalk1_PAR);
    ann.talk(`Good night ${mc.name}.`);

    return jump(v1AfterDates, "v1AfterDates");



};



